import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  OnDestroy
} from '@angular/core';
import { ModalFilterData } from './filter-modal-interface';
import { LayoutService } from 'src/app/layout/layout.service';
import { DataTableConfig } from '../../table/table-interface';
import { CommonServiceLayerService, RequestPayLoadFormat } from 'src/app/services/common-service-layer.service';
import { SharedService } from '../../shared.service';
import { SessionhandlerService } from '../../../services/sessionhandler.service';
import { AlertService } from 'src/app/shared/alert.service';
import { GlobalVariablesService } from 'src/app/layout/global-variables.service';
import { Config } from 'src/app/config/config';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss']
})
export class FilterModalComponent implements OnInit, OnChanges, OnDestroy {

  constructor(
    public modalService: LayoutService,
    public http: CommonServiceLayerService,
    public sharedService: SharedService,
    public alert: AlertService,
    public layoutService: LayoutService,
    public storage: SessionhandlerService,
    public globalVariables: GlobalVariablesService,
    public appService: AppService,
    public router: Router
  ) {
    this.modalAction = new EventEmitter<any>();
    this.selectFieldChanges = new EventEmitter<any>();
  }
  @Input() data: ModalFilterData;
  @Input() parentComponentName;
  @Output() modalAction: EventEmitter<any>;
  @Output() selectFieldChanges: EventEmitter<any>;
  public parentData: any = {
    error_cls: 'error_cls',
    formSubmitted: false,
  };
  public tableConfigData: DataTableConfig;
  public staticForm = [];
  public selectedStaticFields = {};
  ngOnInit() {
    this.onLoadFunctions();
  }
  setStaticForm(res) {
    try {
      const dateTimeFilters = this.globalVariables.FILTER_FORM_MAPPING.dateTimeFilters;
      // this.staticForm = res;
      this.staticForm = JSON.parse(JSON.stringify(res));
      this.staticForm.forEach(element => {
        element.hidden = true;
      });
      this.data.staticFields.forEach(field => {
        let index;
        if (dateTimeFilters.indexOf(field) > -1) {
          index = this.staticForm.findIndex(ele => ele.identifier === field);
        } else {
          index = this.staticForm.findIndex(ele => ele.key === field);
        }
        if (index > -1) {
          this.staticForm[index].hidden = false;
        }
      });
      // Adding Select All key for multi select based on client for side filter pop-up
      // This is for staticFiters
      if (this.appService.DOMAIN_DETAILS().selectAllForFilterModal) {
        this.staticForm.forEach(ele => {
          if (ele.type === 'multiselect') {
            // tslint:disable-next-line: no-string-literal
            ele['selectAll'] = true;
          }
        });
      }
    } catch (error) {
      Config.logger(error);
    }
  }
  DynamicFitersSelectAll() {
    // Adding Select All key for multi select based on client for side filter pop-up
    // This is for DynamicFiters
    if (this.appService.DOMAIN_DETAILS().selectAllForFilterModal) {
      this.data.formData.forEach(ele => {
        if (ele.type === 'multiselect') {
          // tslint:disable-next-line: no-string-literal
          ele['selectAll'] = true;
        }
      });
    }
  }
  ngOnChanges() {
    this.onLoadFunctions();
  }
  onLoadFunctions() {
    this.setTableConfig();
    this.setDefaultOptions();
    this.layoutService.getStaticFilterFields().subscribe(res => {
      this.setStaticForm(res);
    });
    this.DynamicFitersSelectAll();

    // previous selected filters
    this.selectedStaticFields = this.layoutService.getAppliedStaticFilters();
    // ########## Added for binding the previous filter values while clicking on filter button ##########
    // this.selectedStaticFields['parameters'] = this.selectedStaticFields['parameter']
    // this.selectedStaticFields['monitoringStations'] = this.selectedStaticFields['monitoringStation']
    // ##################################################################################################
    this.parentData.noDynamicFieldWidth = this.data.noDynamicFieldWidth;
    // combine previous selected filters with current parent default filters
    this.selectedStaticFields = this.data.inputData = Object.assign(this.selectedStaticFields, this.data.inputData);
    if (!this.parentData.hideOnLoad) {
      document.getElementById('filterModalOpenBtn').click();
    }
  }
  setTableConfig() {
    this.tableConfigData = {
      dtOptions: {
        maxRows: 10,
        searchButton: true,
        columnSearch: false,
        displayOptions: true,
        headerLabel: 'name',
        rowselect: {
          key: 'selected',
          // headerLabel: 'name',
          selectAll: false
        },
        showSelectAll: true
      }
    };
  }
  setDefaultOptions() {
    const temp: ModalFilterData = {
      headerClass: '',
      headerTitle: '',
      width: '1080',
      footerClass: '',
      formData: [],
      showModalClose: true,
      inputData: {},
      buttons: [],
      fadeType: 'left',
      staticFields: []
    };
    this.data = Object.assign(temp, this.data);
  }
  onModalClose() {
    this.modalService.setToggleModal(false);
  }
  btnAction(key) {
    this.parentData.formSubmitted = true;
    // form validation
    if (this.sharedService.getDisabledStatus(this.parentData.error_cls)) {
      return true;
    } else {
      if (this.tableConfigData.tableData) {
        this.data.inputData.selectedParams = this.tableConfigData.tableData.bodyContent.filter(
          ele => ele.selected
        );
        if (this.data.inputData.selectedParams.length === 0) {
          this.alert.open('info', 'message', 'Please Select Atleast One Row');
          return true;
        }
      }
      // dynamic saved data
      let formData = JSON.parse(JSON.stringify(this.data.inputData));
      // combining dynamic and static Filters
      formData = Object.assign(this.modalService.getAppliedStaticFilters(), formData);
      // preserving filters
      this.modalService.setAppliedStaticFilters(formData);
      const combinedForm = [...this.staticForm, ...this.data.formData];
      this.bindStationsName(formData);
      this.modalService.setFiltersData({ data: formData, fields: combinedForm });
      let payLoad: any = {};
      // combinedForm.forEach(ele => {
      combinedForm.filter(ele => !ele.hidden).forEach(ele => {
        payLoad[ele.key] = formData[ele.key];
      });
      if (this.data.wholeFilters) {
        payLoad.wholeFilters = formData;
      }
      try {
        // if (this.data.dateFormat && payLoad.date) {
        //   payLoad = Object.assign(this.sharedService[this.data.dateFormat](payLoad.date), payLoad);
        // }
        if (this.data.dateFormat && payLoad.singleDate) {
          payLoad = Object.assign(this.sharedService[this.data.dateFormat](payLoad.singleDate), payLoad);
        } else {
          payLoad = Object.assign(this.sharedService.formatFromAndToDates(payLoad.date), payLoad);
        }
      } catch (error) {
        Config.logger(error);
      }
      if (this.tableConfigData.tableData) {
        payLoad.selectedParams = this.data.inputData.selectedParams;
      }
      this.modalAction.emit({ button: key, payLoad });
      if (this.data.inputData.siteId) {
        this.storage.api.session.save('siteId', this.data.inputData.siteId);
      }
    }
  }
  selectChange(event) {
    if (event.field.loadTable) {
      this.getFilterData(event.value);
    }
    this.selectFieldChanges.emit(event);
  }
  getFilterData(siteId) {
    const payLoad = {
      siteId,
      avgFlag: this.data.filterFlag
    };
    try {
      const request: RequestPayLoadFormat = {
        api: 'getTableDataBasedOnSite',
        method: 'postText',
        loader: true,
        type: 'API',
        hideErrorMessage: false,
        payLoad
      };
      this.http.API_REQUEST(request).subscribe(response => {
        if (response.status) {
          this.tableConfigData.tableData = response.data.tableData;
        } else {
          this.sharedService.serviceErrorMessage(response.message);
        }
      });
    } catch (error) {
      Config.logger(error);
    }
  }
  bindStationsName(formData) {
    try {
      formData.selectedStation = '';
      if (this.data.staticFields.indexOf('station') > -1) {
        formData.selectedStation = formData.stationName;
      } else if (this.data.staticFields.indexOf('stations') > -1) {
        this.createStringList(this.staticForm, formData);
      } else if (this.data.formData.findIndex(ele => ele.key === 'station') > -1) {
        formData.selectedStation = formData.stationName;
      } else if (this.data.formData.findIndex(ele => ele.key === 'stations') > -1) {
        this.createStringList(this.data.formData, formData);
      }
    } catch (error) {
      console.log(error);
    }
  }
  createStringList(dfm, formData) {
    let objIndex;
    const index = dfm.findIndex(ele => ele.key === 'stations');
    if (dfm[index]) {
      formData.stations.forEach((stationId, i) => {
        objIndex = dfm[index].options.findIndex(station => station.key === stationId);
        formData.selectedStation += ` ${dfm[index].options[objIndex].label}${i === formData.stations - 1 ? '' : ','}  `;
      });
    }
  }

  ngOnDestroy() {
    try {
      //
    } catch (error) {
      Config.logger(error);
    }
  }

}
